/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const GroupCategoryCd = {
    CzechRailways: 'CzechRailways',
    Other: 'Other'
} as const;
export type GroupCategoryCd = typeof GroupCategoryCd[keyof typeof GroupCategoryCd];


export function instanceOfGroupCategoryCd(value: any): boolean {
    for (const key in GroupCategoryCd) {
        if (Object.prototype.hasOwnProperty.call(GroupCategoryCd, key)) {
            if (GroupCategoryCd[key as keyof typeof GroupCategoryCd] === value) {
                return true;
            }
        }
    }
    return false;
}

export function GroupCategoryCdFromJSON(json: any): GroupCategoryCd {
    return GroupCategoryCdFromJSONTyped(json, false);
}

export function GroupCategoryCdFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroupCategoryCd {
    return json as GroupCategoryCd;
}

export function GroupCategoryCdToJSON(value?: GroupCategoryCd | null): any {
    return value as any;
}

export function GroupCategoryCdToJSONTyped(value: any, ignoreDiscriminator: boolean): GroupCategoryCd {
    return value as GroupCategoryCd;
}

